export default __webpack_public_path__ + "static/media/spratt4.561eb648.jpg";